module.exports = __webpack_public_path__ + "img/magento-custom-development_small@2x.c6ae0547.webp";